/**
 * JSP-Markenfarben (Fuchs-Logo + Nacht-Illustration).
 * Stabile Chart-Paletten: gleiche Labels → gleiche Farbe.
 */

export const JSP = {
  navy: '#0A2F6B',
  blue: '#1B4F9C',
  sky: '#5B8FCF',
  green: '#6BA539',
  yellow: '#F9A800',
  gold: '#E8A317',
  red: '#A6192E',
  ink: '#0B1C33',
  mist: '#E8EEF6',
};

/** Boolean / Compliance: true → green, false → red */
export const COMPLIANCE_COLORS = [JSP.green, JSP.red];

/** Ältere Versionen (neueste = green separat). */
const VERSION_CYCLE = [
  JSP.navy,
  JSP.yellow,
  JSP.blue,
  JSP.red,
  JSP.sky,
  JSP.gold,
  '#3D6B35',
  '#0D4A7A',
  '#C47A00',
];

const CHART_CYCLE = [
  JSP.navy,
  JSP.green,
  JSP.yellow,
  JSP.blue,
  JSP.red,
  JSP.sky,
  JSP.gold,
  '#3D6B35',
  '#0D4A7A',
  '#C47A00',
];

/** Zerlegt "18.5.1 (a)" / "15.0" in Zahlenvergleiche. */
export function parseVersionParts(label) {
  const text = String(label || '').trim();
  const match = text.match(/(\d+(?:\.\d+)*)/);
  if (!match) return null;
  return match[1].split('.').map((part) => Number.parseInt(part, 10) || 0);
}

export function compareVersions(a, b) {
  const left = parseVersionParts(a) || [];
  const right = parseVersionParts(b) || [];
  const len = Math.max(left.length, right.length);
  for (let i = 0; i < len; i += 1) {
    const l = left[i] || 0;
    const r = right[i] || 0;
    if (l !== r) return l - r;
  }
  return String(a || '').localeCompare(String(b || ''), undefined, { numeric: true });
}

/** Deterministische Farbe aus Label (stabil über Reloads). */
export function colorForLabel(label, index = 0, palette = CHART_CYCLE) {
  const text = String(label || '').trim().toLowerCase();
  if (!text) return palette[index % palette.length];
  let hash = 0;
  for (let i = 0; i < text.length; i += 1) {
    hash = ((hash << 5) - hash) + text.charCodeAt(i);
    hash |= 0;
  }
  const idx = Math.abs(hash) % palette.length;
  return palette[idx];
}

export function colorsForLabels(labels = []) {
  const used = new Set();
  return labels.map((label, index) => {
    let color = colorForLabel(label, index);
    let guard = 0;
    while (used.has(color) && guard < CHART_CYCLE.length) {
      color = CHART_CYCLE[(CHART_CYCLE.indexOf(color) + 1) % CHART_CYCLE.length];
      guard += 1;
    }
    used.add(color);
    return color;
  });
}

/**
 * Versionsdiagramme: höchste Versionsnummer → Grün, Rest stabile Palette ohne Grün-Kollision.
 */
export function colorsForVersions(labels = []) {
  if (!labels.length) return [];
  let newestIndex = 0;
  for (let i = 1; i < labels.length; i += 1) {
    if (compareVersions(labels[i], labels[newestIndex]) > 0) newestIndex = i;
  }

  const used = new Set([JSP.green]);
  return labels.map((label, index) => {
    if (index === newestIndex) return JSP.green;
    let color = colorForLabel(label, index, VERSION_CYCLE);
    let guard = 0;
    while (used.has(color) && guard < VERSION_CYCLE.length) {
      color = VERSION_CYCLE[(VERSION_CYCLE.indexOf(color) + 1) % VERSION_CYCLE.length];
      guard += 1;
    }
    used.add(color);
    return color;
  });
}

export default JSP;
